import request from '@/utils/request'

//测评初始化
export function detail(data) {
    return request({
        url: '/admin/ceping58/detail',
        method: 'POST',
        data: data || {}
    })
}

//开始测评
export function index(data) {
    return request({
        url: '/admin/ceping58/index',
        method: 'POST',
        data: data || {}
    })
}

//查看报告
export function report(data) {
    return request({
        url: '/admin/ceping58/report',
        method: 'POST',
        data: data || {}
    })
}